// third-party
import { FormattedMessage } from 'react-intl';

// assets
import AltRouteIcon from '@mui/icons-material/AltRoute';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import FileUpload from '@mui/icons-material/FileUpload';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import SubscriptionIcon from '@mui/icons-material/SubscriptionsOutlined';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SETTINGS ||============================== //

const settings: NavItemType = {
    id: 'settings',
    title: <FormattedMessage id="Settings" />,
    icon: SettingsIcon,
    type: 'group',
    url: ERoutes.crmSettings,
    children: [
        {
            id: 'crm-settings',
            title: 'Customer journey settings',
            type: 'item',
            icon: AltRouteIcon,
            url: ERoutes.crmSettings,
            breadcrumbs: false
        },
        {
            id: 'crm-calendar-settings',
            title: 'Calendar settings',
            type: 'item',
            icon: EventAvailableIcon,
            url: ERoutes.crmCalendarSettings,
            breadcrumbs: false
        },
        {
            id: 'promo-codes',
            title: 'Promo codes',
            type: 'item',
            icon: SubscriptionIcon,
            url: ERoutes.promoCodes,
            breadcrumbs: false
        },
        {
            id: 'admins',
            title: 'Team members',
            type: 'item',
            icon: PersonIcon,
            url: '/admin/list',
            breadcrumbs: false,
            roles: ['superAdmin']
        },
        {
            id: 'crm-import',
            title: 'Import',
            type: 'item',
            icon: FileUpload,
            url: ERoutes.crmImport,
            breadcrumbs: false
        },
        {
            id: 'settings',
            title: 'General settings',
            type: 'item',
            icon: SettingsIcon,
            url: 'settings/edit'
        }
    ]
};

export default settings;
